// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__iZIsl","content":"Home_content__Iy+Sd","chartPanel":"Home_chartPanel__d3uE5","searchButton":"Home_searchButton__I2soV"};